/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
//const { registerLinkResolver } = require("gatsby-source-prismic-graphql")
//const { linkResolver } = require("./src/utils/linkResolver")

//registerLinkResolver(linkResolver)

// ES5 way
// exports.onClientEntry = () => {
// ES6 way
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    require(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}

export const onRouteUpdateDelayed = () => {
  //console.log("loading")
}
